import { HttpError } from '../connectivity/http-error';

/**
 * Which message a failed settings save shows: no permission (403) or a general failure. Shared by the
 * tenant theme editor (feature plan 0054) and the settings page "Allgemein" (feature plan 0068), whose
 * saves both settle through `CommandBus.dispatchCommandForResult`.
 */
export function saveFailureKind(error: unknown): 'forbidden' | 'failed' {
    return error instanceof HttpError && error.status === 403 ? 'forbidden' : 'failed';
}
